// extracted by mini-css-extract-plugin
export default {"title":"AddressInfoClientForm_title__y0LWQ"};